import { FbClientBuilder, UserBuilder } from '@featbit/js-client-sdk';

import { FeatbitConfig, makeFeatbitLogger } from './config';

export async function initFeatbit({ logger = console, sdkKey, streamingUri, eventsUri, userKeyId }: FeatbitConfig) {
  const featbitUser = new UserBuilder(userKeyId).build();

  const featbitClient = new FbClientBuilder({ logger: makeFeatbitLogger(logger) })
    .sdkKey(sdkKey)
    .streamingUri(streamingUri)
    .eventsUri(eventsUri)
    .user(featbitUser)
    .build();

  try {
    await featbitClient.waitForInitialization();
  } catch (err) {
    logger.error(err, 'Failed to initialize Featbit');
  }

  return { featbitClient, featbitUser };
}
